import React, { type ReactNode } from 'react';
import { EmpreenderApps } from '../lib/AppsArray';
import { useTranslation } from '../lib/i18n/TranslationContext';

export interface appProps {
	icon: ReactNode;
	name: string;
	eplus: string;
	link?: string;
	hide?: boolean;
	tags: string[];
	slug: string;
	content: string;
	genero?: string
	suportLink?: string;
}

const ContainerApp = ({ app }: { app: appProps }) => {
	const { t } = useTranslation();
	return (
		<a href={app.link} target='_blank' className='w-[95%] h-auto rounded-lg flex flex-row gap-3 items-center bg-white p-2 [@container_(min-width:900px)]:w-[300px] [@container_(min-width:900px)]:items-start [@container_(min-width:900px)]:bg-transparent [@container_(min-width:900px)]:p-0'>
			<div className='size-12 flex-shrink-0 rounded-lg shadow-[inset_0px_0px_0px_1px_rgba(0,_0,_0,_0.10)] flex items-center justify-center'>{app.icon}</div>

			<div>
				<p className='text-gray-900 text-base not-italic font-medium leading-normal'>{t(app.name)}</p>

				<p className='text-gray-500 text-[13px] not-italic font-medium leading-5'>{t(app.content)}</p>
			</div>
		</a>
	);
};

const FrequentApps = ({ apps }: { apps: string[] }) => {
	const { t } = useTranslation();

	const selectedApps = EmpreenderApps.filter((app) =>
		apps.some((value) => {
			const lowerValue = value.toLowerCase();
			return app?.name?.toLowerCase().includes(lowerValue) || app?.eplus?.toLowerCase().includes(lowerValue) || app?.slug?.toLowerCase().includes(lowerValue) || (Array.isArray(app?.tags) && app.tags.some((tag) => tag?.toLowerCase().includes(lowerValue)));
		})
	);

	return (
		<>
			<div className='[container-type:inline-size] flex flex-row flex-wrap items-center justify-center gap-4 max-w-5xl w-full p-0'>
				<div className='w-[96%] [@container_(min-width:900px)]:p-6'>
					<h1 className='w-full text-gray-900 text-lg not-italic font-semibold leading-7'>{t('Frequentemente usados juntos')}</h1>

					<div className='w-full flex flex-row items-center flex-wrap justify-center gap-4 mt-6'>
						{selectedApps.map((app, index) => (
							<React.Fragment key={index}>
								<ContainerApp app={app} />
							</React.Fragment>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default FrequentApps;
